/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useState } from 'react'
import { useServiceContext } from '../../../root'
import ActionsMenuBig from '../../../components/shared/ActionsMenuBig'
import { ModalImport } from '../../../components/modals/ModalImport'

interface PageMenuProps {
  onAddFolderStrctTplType: () => void
  onExportStart?: () => void
  onExportEnd?: () => void
}

const PageMenu: React.FC<PageMenuProps> = ({ onAddFolderStrctTplType, onExportStart, onExportEnd }) => {
  const context = useServiceContext()
  const { translate } = context.service.filter
  const { toast } = context.service
  const [showImportModal, setShowImportModal] = useState(false)

  const handleExport = async () => {
    try {
      // Start loading
      if (onExportStart) {
        onExportStart()
      }

      // Export all folder structure template types using FOLDER_STRUCTURE_TYPES entity constant
      await context.api.settings.exportSettingsData('FOLDER_STRUCTURE_TYPES', undefined, undefined, translate)
    } catch (error) {
      toast.error(translate('SETTINGS_IMPORT_FAIL'))
    } finally {
      // End loading
      if (onExportEnd) {
        onExportEnd()
      }
    }
  }

  const settings = {
    menuId: 'page',
    items: [
      {
        value: 'SETTINGS_FOLDER_STRUCTURE_ADD',
        action: () => {
          onAddFolderStrctTplType()
        }
      },
      {
        value: 'SETTINGS_FOLDER_STRUCTURE_IMPORT',
        action: () => {
          setShowImportModal(true)
        }
      },
      {
        value: 'SETTINGS_FOLDER_STRUCTURE_EXPORT',
        action: handleExport
      }
    ]
  }

  return (
    <div className="dropdown">
      <ActionsMenuBig {...settings} />
      {showImportModal && (
        <ModalImport
          importType={context.constant.system.settings.entities.FOLDER_STRUCTURE_TYPES}
          show={showImportModal}
          onClose={() => {
            setShowImportModal(false)
          }}
        />
      )}
    </div>
  )
}

export default PageMenu
